import { Component, computed, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import {
    UnrealizedVisitListComponent,
} from '../../../components/services/unrealized-visit-list/unrealized-visit-list.component';
import { routeParams } from '../../../../shared/shared.global-service';

@Component({
    selector: 'app-folder-unrealized-visit-page',
    templateUrl: './folder-unrealized-visit-page.component.html',
    styleUrl: './folder-unrealized-visit-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        UnrealizedVisitListComponent,
    ],
})
export class FolderUnrealizedVisitPageComponent extends SubscriptionComponent {

    protected folderId = computed(() => Number(routeParams.folderId() || 0));

}
